import React, { Component } from 'react'

class Desktop extends Component {
	state = {
		name: '',
		title: {
			text: '',
			color: '',
		},
	}

	addSection = () => {
		console.log('addSection')
	}

	render() {
		return (
			<div>
				<h1>Custom Form</h1>
				<div>
					<span>name: </span>
					<input
						onChange={(e) =>
							this.setState({
								name: e?.target?.value,
							})
						}
						value={this.state?.name}
					/>
				</div>
				<div>
					<span>title color: </span>
					<input
						onChange={(e) =>
							this.setState({
								title: {
									...this.state?.title,
									color: e?.target?.value,
								},
							})
						}
						value={this.state?.title?.color}
					/>
				</div>
				<div>
					<span>title text: </span>
					<input
						onChange={(e) =>
							this.setState({
								title: {
									...this.state?.title,
									text: e?.target?.value,
								},
							})
						}
						value={this.state?.title?.text}
					/>
				</div>
				<div>
					<span>description color: </span>
					<input
						onChange={(e) =>
							this.setState({
								description: {
									...this.state?.description,
									color: e?.target?.value,
								},
							})
						}
						value={this.state?.description?.color}
					/>
				</div>
				<div>
					<span>description text: </span>
					<input
						onChange={(e) =>
							this.setState({
								description: {
									...this.state?.description,
									text: e?.target?.value,
								},
							})
						}
						value={this.state?.description?.text}
					/>
				</div>
				<div>
					<span>display type: </span>
					<select
						name="custom_for_page_display_type"
						id="custom_for_page_display_type"
						value={this.state?.display_type}
						onChange={(e) =>
							this.setState({
								display_type: e?.target?.value,
							})
						}
					>
						<option value="popover">Popover</option>
						<option value="embedded">Embedded</option>
					</select>
				</div>
				<div>
					<span>submit_button text: </span>
					<input
						onChange={(e) =>
							this.setState({
								submit_button: {
									...this.state?.submit_button,
									text: e?.target?.value,
								},
							})
						}
						value={this.state?.submit_button?.text}
					/>
				</div>
				<div>
					<span>submit_button text_color: </span>
					<input
						onChange={(e) =>
							this.setState({
								submit_button: {
									...this.state?.submit_button,
									text_color: e?.target?.value,
								},
							})
						}
						value={this.state?.submit_button?.text_color}
					/>
				</div>
				<div>
					<span>submit_button background_color: </span>
					<input
						onChange={(e) =>
							this.setState({
								submit_button: {
									...this.state?.submit_button,
									background_color: e?.target?.value,
								},
							})
						}
						value={this.state?.submit_button?.background_color}
					/>
				</div>
				<div>
					<span>background_color: </span>
					<input
						onChange={(e) =>
							this.setState({
								background_color: e?.target?.value,
							})
						}
						value={this.state?.background_color}
					/>
				</div>
				<div>
					<span>font: </span>
					<select
						name="custom_form_page_font"
						id="custom_form_page_font"
						value={this.state?.font}
						onChange={(e) =>
							this.setState({
								font: e?.target?.value,
							})
						}
					>
						{[
							'Arial',
							'Arial Black',
							'Bookman',
							'Comic Sans MS',
							'Courier New',
							'Garamond',
							'Georgia',
							'Helvetica',
							'Impact',
							'Palatino',
							'Times New Roman',
							'Times',
							'Trebuchet MS',
							'Verdana',
						].map((fontName) => (
							<option
								key={`addOrEditCustomFormFontName-${fontName}`}
								value={fontName}
							>
								{fontName}
							</option>
						))}
					</select>
				</div>
				<div>
					<span>text_color: </span>
					<input
						onChange={(e) =>
							this.setState({
								text_color: e?.target?.value,
							})
						}
						value={this.state?.text_color}
					/>
				</div>
				<div>
					{this.state?.form?.sections?.map?.((section, idx) => (
						<div>{`section ${idx}`}</div>
					))}
				</div>
				<div>
					<button onClick={() => this.addSection()}>Add Section</button>
				</div>
			</div>
		)
	}
}

export default Desktop
